module.exports = __webpack_public_path__ + "img/datacenter.fa15b55.svg";